import React, { useEffect, useState } from "react";
import PopAdminPresenter from "@/presenters/screens/pop-admin.presenter";
import { Container } from "reactstrap";
import StepsPop from "../../steps-pop";

export interface IPropsStep {
    columns: any;
    data: any;
}

const MRI: React.FC<IPropsStep> = ({ columns, data }: IPropsStep) => {
    const [dataSource, setDataSource] = useState<any>(null);
    const [dataColumns, setDataColumns] = useState<any>(null);
    const [yearDataColumns, setYearDataColumns] = useState<any>(null);
    const [itemYears, setItemYears] = useState<any>(null);

    const view: any = {
        state: {
        columns,
        dataColumns,
        data,
        setItemYears,
        setDataSource,
        },
    };

    const presenter = new PopAdminPresenter(view);

    useEffect(() => {
        if (data && columns) {
            let { auxCol, auxYearCol }: any = presenter.getDataColumnsStep4Mri(presenter.formMasters);
            setDataColumns(auxCol);
            setYearDataColumns(auxYearCol);
        }
    }, [data, columns]);

    return (
        <Container fluid={true}>
            {dataColumns && dataSource && yearDataColumns && (
                <StepsPop
                    yearLabel={presenter.currentLabels.get("PopAdminYears")} index={6}
                    columns={dataColumns}
                    data={dataSource}
                    yearsColumn={yearDataColumns}
                    itemYears={itemYears}
                    onSelectionChanged={presenter.onSelectionChangedStep}
                />
            )}
        </Container>
    );
};

export default MRI;
